var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.36377 20.6347V19.3701C0.36377 14.9063 4.52346 12.5043 10.4806 12.5043C16.4368 12.5043 20.5973 14.9063 20.5973 19.3701V20.6347H0.36377ZM10.4806 14.3157C6.67686 14.3157 3.85037 15.8219 3.0928 18.1075H17.8673C17.1108 15.8219 14.2844 14.3157 10.4806 14.3157ZM10.4806 10.5249C7.69292 10.5249 5.42316 8.25714 5.42316 5.47045C5.42316 2.68275 7.69292 0.416016 10.4806 0.416016C13.2693 0.416016 15.5389 2.68275 15.5389 5.47045C15.5389 8.25714 13.2693 10.5249 10.4806 10.5249ZM10.4806 2.94423C9.08577 2.94423 8.64127 4.0776 8.64127 5.47045C8.64127 6.86429 9.08577 7.99766 10.4806 7.99766C11.8755 7.99766 13.8508 6.86429 13.8508 5.47045C13.8508 4.0776 11.8755 2.94423 10.4806 2.94423Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderUserIcon);
export default __webpack_public_path__ + "static/media/header-user-icon.ee1277e6ce8e4e674c1051cc977ef793.svg";
export { ForwardRef as ReactComponent };